export function getKalturaURL(videoURI?: string) {
  return `https://cdnsecakmi.kaltura.com/p/966871/thumbnail/entry_id/${videoURI}/width/600`;
}
